export enum OnOffFeature {
  ON        = 'ON',
  OFF       = 'OFF',
}

export enum InheritableOnOffFeature {
  INHERITED = 'INHERITED',
  ON        = 'ON',
  OFF       = 'OFF',
}
